module.exports = __webpack_public_path__ + "static/img/dispensing.0db19a3f.png";